import React, { useState, Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
const mockSections = [{
  id: 1,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 2,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 3,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 4,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 5,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 6,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 7,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 8,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 9,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 10,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 11,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 12,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 13,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 14,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 15,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 16,
  name: 'sdgdg',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}, {
  id: 17,
  name: 'xcbxcbxcxcb',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}, {
  id: 18,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 0,
  position: '0',
  course: ''
}, {
  id: 19,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 0,
  position: '0',
  course: ''
}, {
  id: 20,
  name: 'test8',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}];
export function CourseSections() {
  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  return <div className="space-y-4" data-id="element-305">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-306">Course Sections</h1>

      {/* Filters */}
      <div className="space-y-2" data-id="element-307">
        <div data-id="element-308">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-309">Courses</label>
          <select value={selectedCourse} onChange={e => setSelectedCourse(e.target.value)} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[240px]" data-id="element-310">
            <option value="" data-id="element-311">All</option>
            <option value="avoid" data-id="element-312">
              Avoid The Oops: Contract Smarts for Agents
            </option>
            <option value="bmc" data-id="element-313">BMC #1B Property Management</option>
            <option value="broker" data-id="element-314">Broker Management Clinic</option>
          </select>
        </div>
        <div data-id="element-315">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-316">
            Sections
          </label>
          <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-317">
            <option value="" data-id="element-318">All</option>
          </select>
        </div>
        <div className="flex items-center gap-4" data-id="element-319">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-320">
            Search
          </Button>
          <div className="flex items-center gap-2" data-id="element-321">
            <span className="text-sm text-slate-600" data-id="element-322">course id:</span>
            <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections/add')} data-id="element-323">
              <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-324" />
              Add
            </Button>
          </div>
        </div>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-325">
        <div className="overflow-x-auto" data-id="element-326">
          <table className="w-full text-sm text-left" data-id="element-327">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-328">
              <tr data-id="element-329">
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-330">Name</th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-331">
                  Question Types
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-332">
                  Required Time
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-24" data-id="element-333">
                  Position
                </th>
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-334">Courses</th>
                <th className="px-4 py-3 text-center w-36" data-id="element-335">
                  <div data-id="element-336">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-337">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-338">
              {mockSections.map(row => <tr key={row.id} className="hover:bg-slate-50" data-id="element-339">
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-340">
                    {row.name}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-341">
                    {row.questionTypes}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-342">
                    {row.requiredTime || ''}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-343">
                    {row.position}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-344">
                    {row.course && <button className="text-blue-600 hover:underline text-left" data-id="element-345">
                        {row.course}
                      </button>}
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-346">
                    <div className="flex items-center justify-center gap-2" data-id="element-347">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-348">
                        <Eye className="h-4 w-4" data-id="element-349" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/edit/${row.id}`)} data-id="element-350">
                        <Edit className="h-4 w-4" data-id="element-351" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-352">
                        <Trash2 className="h-4 w-4" data-id="element-353" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-354">
        <button className="hover:underline" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} data-id="element-355">
          &lt;&lt; previous
        </button>
        <span className="text-slate-400" data-id="element-356">|</span>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n, i) => <Fragment key={n} data-id="element-357">
            {i > 0 && <span className="text-slate-400" data-id="element-358">|</span>}
            <button onClick={() => setCurrentPage(n)} className={`hover:underline ${currentPage === n ? 'text-slate-900 font-medium' : ''}`} data-id="element-359">
              {n}
            </button>
          </Fragment>)}
        <span className="text-slate-400" data-id="element-360">|</span>
        <button className="hover:underline" onClick={() => setCurrentPage(Math.min(9, currentPage + 1))} data-id="element-361">
          next &gt;&gt;
        </button>
      </div>
    </div>;
}